import { deleteRequest, getRequest, patchRequest, postRequest, severityCode } from "./httpClient";

const END_POINT = "project";

const getProjectList = async () => {
  return await getRequest(`${END_POINT}/list`);
};

const getProjects = async (currentPage, pageSize, sortBy, sortDesc, filterData) => {
  const response = await postRequest(`${END_POINT}/overview`, { filterData: filterData }, { pageNumber: currentPage, pageSize: pageSize, sortBy: sortBy, sortDesc: sortDesc });
  return response;
};

const getProjectFilterOptions = async (fieldName, text) => {
  const response = await getRequest(`${END_POINT}/autocomplete/${fieldName}`, { text: text });
  return response.data;
};

const getProject = async (projectId) => {
  return await getRequest(`${END_POINT}/${projectId}/detail`);
};

const getProjectUsers = async (projectId, currentPage, pageSize, sortBy, sortDesc, filterData) => {
  const response = await postRequest(`${END_POINT}/${projectId}/users`, { filterData: filterData }, { pageNumber: currentPage, pageSize: pageSize, sortBy: sortBy, sortDesc: sortDesc });
  return response;
};

const getProjectUsersFilterOptions = async (projectId, fieldName, text) => {
  const response = await getRequest(`${END_POINT}/${projectId}/users/autocomplete/${fieldName}`, { projectId: projectId, text: text });
  return response.data;
};

const getProjectReports = async (projectId, currentPage, pageSize, sortBy, sortDesc, filterData) => {
  const response = await postRequest(
    `${END_POINT}/${projectId}/reports`,
    { filterData: filterData },
    { pageNumber: currentPage, pageSize: pageSize, sortBy: sortBy, sortDesc: sortDesc }
  );
  return response;
};

const getProjectReportsList = async () => {
  return await getRequest(`${END_POINT}/reports/list`);
};

const getProjectReportsFilterOptions = async (projectId, fieldName, text) => {
  const response = await getRequest(`${END_POINT}/${projectId}/reports/autocomplete/${fieldName}`, { projectId: projectId, text: text });
  return response.data;
};

const addProject = async (projectData) => {
  return await postRequest(`${END_POINT}`, { ...projectData });
};

const updateProject = async (projectId, projectData) => {
  console.log("project.api, updateProject: ", projectData);
  return await patchRequest(`${END_POINT}/${projectId}`, { ...projectData });
};

const deleteProject = async (projectId) => {
  return await deleteRequest(`${END_POINT}/${projectId}`);
};

const getCllParties = async () => {
  return await getRequest(`${END_POINT}/partyList`);
};

const hasCertifiedMeasures = async (partyReference) => {
  return await getRequest(`${END_POINT}/${partyReference}/hasCertifiedMeasures`);
};

const hasUndefinedVariants = async (partyReference) => {
  return await getRequest(`${END_POINT}/${partyReference}/hasUndefinedVariants`);
};

const hasUndefinedStatusses = async (partyReference) => {
  return await getRequest(`${END_POINT}/${partyReference}/hasUndefinedStatusses`);
};

const getMeasuresCheckInfoSummary = async (partyReference) => {
  return await getRequest(`${END_POINT}/${partyReference}/measuresCheckInfoSummary`);
};

const getMeasuresCheckInfoPaged = async (partyReference, currentPage, pageSize, sortBy, sortDesc) => {
  return await getRequest(`${END_POINT}/${partyReference}/measuresCheckInfoPaged`, { pageNumber: currentPage, pageSize: pageSize, sortBy: sortBy, sortDesc: sortDesc });
};

const createBulkUploadXML = async (partyReference, xmlData) => {
  console.log("project.api, createBulkUploadXML, projectId, xmlData: ", partyReference, xmlData);
  return await postRequest(`${END_POINT}/${partyReference}/createBulkUploadXML`, { ...xmlData });
};

const createCsv = async (token, partyReference) => {
  return await postRequest(`${END_POINT}/${token}/createCsv/${partyReference}`);
};

const getPartyEnergyEfficiencyObligatory = async (partyReference) => {
  return getRequest(`${END_POINT}/${partyReference}/energyEfficiencyObligatory`);
};

export {
  getCllParties,
  getProjectList,
  getProjects,
  getProjectFilterOptions,
  getProject,
  getProjectUsers,
  getProjectUsersFilterOptions,
  getProjectReports,
  getProjectReportsList,
  getProjectReportsFilterOptions,
  addProject,
  updateProject,
  deleteProject,
  hasCertifiedMeasures,
  hasUndefinedVariants,
  hasUndefinedStatusses,
  getMeasuresCheckInfoSummary,
  getMeasuresCheckInfoPaged,
  createBulkUploadXML,
  createCsv,
  getPartyEnergyEfficiencyObligatory, 
  severityCode,
};
